import actionTypes from 'SRC/modules/redux/actionTypes'

export const setCurrentAd = (ad) => {
  return {
    type: actionTypes.SET_CURRENT_AD,
    payload: ad
  }
}
